<!-- USA Banner -->
<header #bannerContainer id="us_official_header_banner" class="usa-header usa-header-extended" role="banner" aria-label="Page Header">
  <div class="usa-banner">
    <div class="usa-accordion">
      <header class="usa-banner-header" aria-label="Official United States government Website Disclaimer">
        <div class="usa-grid usa-banner-inner">
        <img src="/app/aw-ui-angular/assets/vendor/usabanner/img/us_flag_small.png" alt="U.S. flag">
        <p>An official website of the United States government</p>
        <button #bannerButton 
        	class="usa-accordion-button usa-banner-button" 
        	aria-expanded="false" 
        	aria-controls="gov-banner"
        	type="button">
          <span class="usa-banner-button-text">Here's how you know</span>
        </button>
        </div>
      </header>
      <div #bannerContent
      	class="usa-banner-content usa-grid usa-accordion-content" 
      	id="gov-banner" 
      	aria-hidden="true">
        <div class="usa-banner-guidance-gov usa-width-one-half">
          <img class="usa-banner-icon usa-media_block-img" src="/app/aw-ui-angular/assets/vendor/usabanner/img/icon-dot-gov.png" alt="Dot gov">
          <div class="usa-media_block-body">
            <p>
                <strong>
                    Official websites use .gov
                </strong>
                <br>
                A <strong>.gov</strong> website belongs to an official government organization in the United States.
            </p>
          </div>
        </div>
        <div class="usa-banner-guidance-ssl usa-width-one-half">
          <img class="usa-banner-icon usa-media_block-img" src="/app/aw-ui-angular/assets/vendor/usabanner/img/icon-https.png" alt="SSL">
          <div class="usa-media_block-body">
          <p>
              <strong>Secure .gov websites use HTTPS</strong>
              <br>
              A <strong>lock</strong> ( <span class="icon-lock"><svg xmlns="http://www.w3.org/2000/svg" width="52" height="64" viewBox="0 0 52 64" class="usa-banner__lock-image" role="img" aria-labelledby="banner-lock-title banner-lock-description"><title id="banner-lock-title">Lock</title><desc id="banner-lock-description">A locked padlock</desc><path fill="#000000" fill-rule="evenodd" d="M26 0c10.493 0 19 8.507 19 19v9h3a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V32a4 4 0 0 1 4-4h3v-9C7 8.507 15.507 0 26 0zm0 8c-5.979 0-10.843 4.77-10.996 10.712L15 19v9h22v-9c0-6.075-4.925-11-11-11z"></path></svg></span> ) or <strong>https://</strong> means you've safely connected to the .gov website. Share sensitive information only on official, secure websites.

            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<!-- END USA Banner -->
